import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import {
  unhandledBankPaymentsCompleted,
  unhandledBankPaymentsUpdated,
} from "store/actions/unhandledBankPaymentsActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { UnhandledBankPaymentsFooterProps } from "models/propTypes/paymentPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { usePaymentService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const UnhandledBankPaymentsFooter: React.FC<UnhandledBankPaymentsFooterProps> = (props) => {
  const paymentService = usePaymentService();
  const { selectedPayments, reloadHandler, disableSuccessMessages } = props;
  const dispatch = useDispatch();

  const onPaymentsAccept = () => {
    const paymentsToSign = {
      incomingInvoiceManualPaymentIds: selectedPayments.incomingInvoiceManualPayments?.map((p) => p.id),
      incomingInvoicePaymentFilesToSignIds: selectedPayments.incomingInvoicePaymentFilesToSign?.map((p) => p.id),
      receiptPayoutFilesToSignIds: selectedPayments.receiptPayoutFilesToSign?.map((p) => p.id),
      salaryPayoutFilesToSignIds: selectedPayments.salaryPayoutFilesToSign?.map((p) => p.id),
      manualPayoutsToSignIds: selectedPayments.manualPayoutsToSign?.map((p) => p.id),
    } as WintSuperkollAPIModel.BankPaymentInformationPut;
    return paymentService.approvePayments(paymentsToSign);
  };

  const onAcceptSuccess = () => {
    reloadHandler((payments) => {
      if (payments) {
        dispatch(unhandledBankPaymentsUpdated(payments));
      } else {
        dispatch(unhandledBankPaymentsCompleted(0));
      }
    });
  };

  return (
    <PageFooter
      actions={[
        {
          text: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.MarkedAsApproved)}${
            props.selectedPaymentsCount > 0 ? ` (${props.selectedPaymentsCount})` : ""
          }`,
          onClick: onPaymentsAccept,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.SubmitSuccessMessage),
          isDisabled: props.selectedPaymentsCount === 0,
          onActionSuccess: onAcceptSuccess,
        },
      ]}
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default UnhandledBankPaymentsFooter;
